export default __webpack_public_path__ + "static/media/cancel.0dce4b06.svg";